import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';


import { MainComponent } from './layout/main.component';
import { AppNavigationComponent } from './layout/app-navigation.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LogoutComponent } from './logout/logout.component';
import { NoDataTableComponent } from './no-data-table/no-data-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeatureCardComponent, FeatureFilterDirective } from './feature-card/feature-card.component';
import { MainEffects } from './layout/main.effects';
import { RouterModule } from '@angular/router';
import { ContentCardComponent, ContentFilterDirective } from './content-card/content-card.component';
import { QaBannerComponent } from './qa-banner/qa-banner.component';
import { ResourceCenterComponent } from './layout/resource-center/resource-center.component';
import { ResourceRequestModalComponent } from './layout/resource-center/resource-request-modal/resource-request-modal.component';
import { LogoutService } from './logout/logout.service';
import { Modal, ModalModule } from 'atlas-modal';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { LegacyModule } from 'atlas-legacy';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TooltipModule } from 'atlas-tooltip';
import { FieldModule } from 'atlas-field';
import { AppBarModule } from 'atlas-app-bar';
import { CardModule } from 'atlas-card';
import { NavigationMenuModule } from 'atlas-navigation';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
import { AvatarModule } from 'atlas-avatar';
import { DrawerModule } from 'atlas-drawer';
export const COMPONENTS = [
  MainComponent,
  AppNavigationComponent,
  HeaderComponent,
  FooterComponent,
  LogoutComponent,
  NoDataTableComponent,
  FeatureCardComponent,
  FeatureFilterDirective,
  ContentCardComponent,
  ContentFilterDirective,
  QaBannerComponent,
  ResourceCenterComponent,
  ResourceRequestModalComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ModalModule,
    IconModule,
    ButtonModule,
    LegacyModule,
    TableModule,
    CdkModule,
    ScrollingModule,
    TooltipModule,
    FieldModule,
    AppBarModule,
    CardModule,
    NavigationMenuModule,
    MenuModule,
    ListModule,
    AvatarModule,
    LinkModule,
    DrawerModule,
    EffectsModule.forFeature([MainEffects])
  ],
  providers: [LogoutService],
  exports: COMPONENTS,
})
export class SharedModule {
}
